module.exports = __webpack_public_path__ + "images/a53b5d1b48f31b264a532978fa8eb702-kitchen_wooden.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/kitchen_wooden.jpg
// module id = ./src/assets/images/content/kitchen_wooden.jpg
// module chunks = 0